import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { Page, LayoutSideNavigation } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import css from './ScholarshipPage.module.css';

export const ScholarshipPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const title = intl.formatMessage({ id: 'ScholarshipPage.title' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer
              currentPage="ScholarshipPage"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              isWhiteBgNav={false}
              isHeaderSticky={true}
            />
          </>
        }
        hideCssMainClass
        sideNav={null}
        currentPage="ScholarshipPage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <h1>College Scholarship Program</h1>
          <p>There is no active Stay Greedless scholarship program at this time.</p>
          <p>
            Any future scholarship will be announced with separate published rules describing
            eligibility, geographic restrictions, application and selection criteria, award terms,
            privacy practices, and all other material conditions. Future scholarship offers will be
            void where prohibited or restricted by law.
          </p>
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

ScholarshipPageComponent.defaultProps = {};

ScholarshipPageComponent.propTypes = {
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const ScholarshipPage = compose(
  connect(mapStateToProps, null),
  injectIntl
)(ScholarshipPageComponent);

export default ScholarshipPage;
